module.exports = __webpack_public_path__ + "static/media/cannot-act.1397a146.wav";